import type { SkillCatalogSkill, SkillTier } from "connected-components/skills/types"
import { formatLastUpdated } from "connected-components/skills/utils/format"

const TIER_LABELS: Record<SkillTier, string> = { licensed: "Core", proprietary: "Tailored", user: "Yours", shared: "Shared" }

export function buildSkillRunPrompt(skill: Pick<SkillCatalogSkill, "name" | "starterPrompt">): string {
  return skill.starterPrompt?.trim() || `Run the ${skill.name} skill.`
}

export function tierLabel(tier: SkillTier): string {
  return TIER_LABELS[tier]
}

export function formatSharedBy(skill: Pick<SkillCatalogSkill, "sharedBy">): string {
  return `Shared by ${skill.sharedBy?.name ?? "—"}`
}

export function formatSkillMeta(skill: SkillCatalogSkill, { withAuthor = false } = {}): string {
  const parts = [`v${skill.version}`]
  const updated = formatLastUpdated(skill.lastUpdated)
  if (updated) parts.push(`Updated ${updated}`)
  if (withAuthor && skill.author) parts.push(skill.author)
  return parts.join(" · ")
}
